@if (userData$ | async; as data ) {
  @if (((customerAdminRole$ | async) || (SGREAmdinRole$ | async))) {
    <div class="container-fluid">
      <app-table-template [columns]="data.columns"
        [tableData]="data.userstableData"
        [allowPagination]="true"
        [filterLegalEntity]="true"
        [rowsPerPage]="10"
        (filteredData)="onFilter($event)"
        (navigateClickEvent)="navigateUserProfile($event)">
      </app-table-template>
    </div>
  }
}
